import { styled } from "leva/plugin";

export const StyledScrollbarVertical = styled("div", {
	display: "flex",
	flexDirection: "column",
	width: "100%",
	height: "100%",
	alignItems: "center",
	overflowX: "hidden",
	overflowY: "auto",
	padding: "2px 2px",
	gap: "2px",

	// WebKit-based browsers (Chrome, Safari, etc.)
	"&::-webkit-scrollbar": {
		width: "1px",
		height: "1px",
	},
	"&::-webkit-scrollbar-thumb": {
		backgroundColor: "rgba(96, 165, 250, 1)",
	},
	"&::-webkit-scrollbar-track": {
		backgroundColor: "transparent",
	},
});
